// import { SearchBarAndFiltersSuscribers } from '../SearchAndFilters/SearchBarAndFilterSuscribers'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getUserForOrganization } from '../../../../redux/actions/Organizations'
import TableHeader from './TableHeader/TableHeader'
import TableItem from './TableItem/TableItem'

import useStyles from './useStyles'

function UserTable ({ id, rows, setRows, setLoading }) {
  const classes = useStyles()
  const dispatch = useDispatch()

  const getUser = async () => {
    const users = await dispatch(getUserForOrganization(id))
    if (users && users !== 'Error') setRows(users)
  }

  // get users of Suscriber of Organization
  useEffect(async () => {
    setLoading(true)
    await getUser()
    setLoading(false)
  }, [id])

  return (
    <>
      <div className={classes.root}>
        <div className={classes.tableWrap}>
          <table className={classes.table}>
            <TableHeader />
            <tbody className={classes.tableBody}>
              {rows &&
                rows.map((item, index) => (
                  <TableItem
                    listIndex={index}
                    key={item.userId}
                    item={item}
                    id={id}
                    setLoading={setLoading}
                  />
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}
export default UserTable
